import type { Post } from '@/@types/post'
import queryClient from '@/utils/queryClient'
import type { Updater } from '@tanstack/query-core'
import { useQuery } from '@tanstack/react-query'

export const IS_REPOST_FORM_MODAL_SHOW_QUERY_OPTIONS_KEY = ['IS_REPOST_FORM_MODAL_SHOW']

export function setIsRepostFormModalShow(updater: Updater<boolean, boolean>) {
	return queryClient.setQueryData<boolean>(
		IS_REPOST_FORM_MODAL_SHOW_QUERY_OPTIONS_KEY,
		updater as Updater<boolean | undefined, boolean | undefined>
	)
}

export function useIsRepostFormModalShow() {
	const { data } = useQuery<boolean>({
		queryKey: IS_REPOST_FORM_MODAL_SHOW_QUERY_OPTIONS_KEY,
		initialData: false,
	})
	return [data, setIsRepostFormModalShow] as const
}

export const REPOST_TARGET_QUERY_OPTIONS_KEY = ['REPOST_TARGET']

export function setRepostTarget(updater: Updater<Post | null, Post | null>) {
	return queryClient.setQueryData<Post | null>(
		REPOST_TARGET_QUERY_OPTIONS_KEY,
		updater as Updater<Post | null | undefined, Post | null | undefined>
	)
}
export function resetRepostTarget() {
	return queryClient.setQueryData(REPOST_TARGET_QUERY_OPTIONS_KEY, null)
}

export function useRepostTarget() {
	const { data } = useQuery<Post | null>({
		queryKey: REPOST_TARGET_QUERY_OPTIONS_KEY,
		initialData: null,
	})
	return [data, setRepostTarget] as const
}
